import {
  useWSModalCustom,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../query/hooks/helpers";
import { useMutationUpdateActivity } from "../../../query/users/mutations";
import { PATH_ONBOARDING_TAX_WITHHOLDINGS } from "../../Onboarding";
import {
  CardOptOutSurvey,
  CardOptOutSurveyRef
} from "../components/CardOptOutSurvey";

type Props = WSModalCustomProps<void>;

export const ModalPauseReminders: React.FC<Props> = modalProps => {
  const history = useHistory();
  const userId = useUserId();
  const [mutate, meta] = useMutationUpdateActivity(userId, {
    onSuccess: () => {
      modalProps.onClose();
    }
  });

  const surveyRef = React.useRef<CardOptOutSurveyRef>(null);

  const handlePauseReminders = () => {
    surveyRef.current?.submit();

    mutate({
      events: {
        taxWithholdingsAlertsDismissed: true
      }
    });
  };

  const handleNevermind = () => {
    modalProps.onClose();
    history.push(PATH_ONBOARDING_TAX_WITHHOLDINGS);
  };

  return (
    <WSModal
      title="Pause reminders"
      size="M"
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Nevermind, complete my setup",
            onClick: handleNevermind,
            kind: "Tertiary"
          },
          {
            label: "Pause reminders for now",
            onClick: handlePauseReminders,
            kind: "Secondary",
            loading: meta.isLoading
          }
        ]
      }}
      {...modalProps}
    >
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          Message received, we’ll pause these reminders for now.
        </WSText.ParagraphSm>

        <CardOptOutSurvey ref={surveyRef} />

        <WSInfoBox title="Prefer to handle taxes on your own? Here's what to remember:">
          <ul>
            <li>Quarterly deadlines: Apr 15, Jun 15, Sep 15, Jan 15</li>
            <li>Set aside 25-30% of income for taxes</li>
            <li>Use IRS Form 1040-ES for payments</li>
            <li>Keep detailed income records</li>
          </ul>

          <p>
            If you change your mind, you can enable tax withholding anytime
            under your “Financial benefits” section. We'll also show a reminder
            closer to quarterly deadlines.
          </p>
        </WSInfoBox>
      </WSList>
    </WSModal>
  );
};

export const useModalPauseReminders = () =>
  useWSModalCustom(ModalPauseReminders);
